/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { SystemReviewService } from 'app/cm/services/system-review-service';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class SaveSystem extends ComponentBase implements IForm {

  ////****************** Fields and Properties ************************************////
  public systemId: string | null = null;
  public systemText: string = '';

  ////****************** Lifecycle events (in order of execution) *****************////
  constructor(
    private readonly service: SystemReviewService,
    private readonly toaster: Toaster,
    ...rest: any[]) {
    super(...rest);
  }

  ////****************** Events ***************************************************////

  ////****************** Functions ************************************************////
  protected buildSystem(): CM.System {
    const saveSystem: CM.System = {
      id: this.systemId,
      description: this.systemText,
      code: null
    };

    return saveSystem;
  }

  ////****************** IForm ****************************************************////
  public hasChanges(): boolean {
    throw new Error('Method not implemented.');
  }

  public async submit(): Promise<boolean> {
    const isSuccess = await this.saveSystem();
    return isSuccess;
  }

  ////****************** Service Calls ********************************************////
  @apiCall
  protected async saveSystem(): Promise<boolean> {
    const insertSystem: CM.System = this.buildSystem();

    let isSuccessful = false;
    try {
      this.state.beginSave();
      const response = await this.service.saveSystem(insertSystem);
      isSuccessful = response.isSuccessful;

      return isSuccessful;
    }
    catch(error) {
      throw error;
    }
    finally {
      if(this.systemId) {
        this.toaster.standard.updated('cm:system.$', isSuccessful);
      } else {
        this.toaster.standard.created('cm:system.$', isSuccessful);
      }
      this.state.endSave();
    }
  }
}
